import FormType from "../../../../../shared/components/FormType";
import { contactFields } from "../../../../../configs/customer";
import {
  ContentWrapper,
  DeleteButton,
  AddButtonText,
  StyledAddButton,
  WarningContactPerson
} from "./Styled";
import AddSectionIcon from "../../../../../shared/svg/AddSection";
import DeleteIcon from "../../../../../shared/svg/DeleteIcon";
import React from "react";
import { color } from "../../../../../shared/styles";

interface ContactListProps {
  contactList: any[];
  onChangeContactList: Function;
  onDeleteContactList: Function;
  onAddContactList: Function;
  validated: boolean;
}

const ContactList = ({
  contactList,
  onChangeContactList,
  onDeleteContactList,
  onAddContactList,
  validated,
}: ContactListProps) => {
  return (
    <>
      {contactList.map((contact, index) => (
        <ContentWrapper key={contact.id}>
          <FormType
            validationScope={`contact_list.${index}.contact.`}
            requireData={{ id: contact.id, ...contact.contact }}
            mergeFormData={onChangeContactList}
            title={`Thông tin người liên hệ ${index + 1}`}
            fields={contactFields}
            validated={validated}
            style={{
              formWrapper: {
                backgroundColor: "#F7F7F7",
                borderRadius: "8px",
                padding: "24px 20px",
                margin: "20px 20px 0 20px",
              },
              contentWrapper: {
                boxShadow: "none",
              },
            }}
          />

          <DeleteButton
            onClick={() => onDeleteContactList(contact.id)}
            disabled={contact.contact.is_default}
          >
            <DeleteIcon color={color.secondary.CHARCOAL} />
          </DeleteButton>
        </ContentWrapper>
      ))}
      <StyledAddButton onClick={() => onAddContactList()}>
        <AddButtonText>Thêm người liên hệ</AddButtonText>
        <AddSectionIcon />
      </StyledAddButton>
    </>
  );
};

export default ContactList;
